// extracted by css-extract-rspack-plugin
export default {"table":"styles_table__BBM0X","borderHorizontal":"styles_borderHorizontal__pE977","borderVertical":"styles_borderVertical__kyOQT"};